import { render } from "./PageForbidden.vue?vue&type=template&id=489b42f8"
import script from "./PageForbidden.vue?vue&type=script&lang=js"
export * from "./PageForbidden.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__